<header class="product-header" [ngClass]="{'dark-mode': isDarkMode}">
  <div class="header-bar">
    <div class="header-inner">
      <div class="header-brand">
        <span class="header-logo-link" title="CenterPoint Energy">
          <img
            alt="CenterPoint Energy Logo - white"
            class="header-logo-image"
            src="https://edge.sitecorecloud.io/centerpointd332-cnpdigital9938-prod15ff-c206/media/project/centerpoint/shared/centerpointenergy-logo-white.svg?iar=0"
          />
        </span>
      </div>
    </div>
  </div>
</header>



